import React from "react";
import { Zap, Factory, BadgeIndianRupee, Smartphone, ShieldCheck, Droplets } from "lucide-react";

const points = [
  { no: "01", icon: Zap, title: "Fast & Reliable", body: "Optimized routing ensures on-time delivery across Bengaluru and beyond.", stat: "18 min", statLabel: "Avg. dispatch time" },
  { no: "02", icon: Factory, title: "Large-scale Capacity", body: "Industrial-grade fulfillment and fleet designed for high-volume demand.", stat: "50K L", statLabel: "Daily throughput" },
  { no: "03", icon: BadgeIndianRupee, title: "Transparent Pricing", body: "Fair, visible pricing — no hidden delivery charges, no surprises.", stat: "₹0", statLabel: "Hidden fees" },
  { no: "04", icon: Smartphone, title: "Smart App Ordering", body: "Reorder, track live, manage addresses — in a few taps.", stat: "4.8★", statLabel: "User rating" },
  { no: "05", icon: ShieldCheck, title: "Trusted at Scale", body: "Businesses and households across Bengaluru rely on Wateriia every day.", stat: "100%", statLabel: "Purity verified" },
];

export default function Why() {
  return (
    <section id="why" className="py-24 md:py-32 bg-[#0b1d2a] text-white relative overflow-hidden">
      <div className="absolute -top-32 right-0 w-[480px] h-[480px] rounded-full bg-[#0ea5e9]/15 blur-3xl" />
      <div className="absolute bottom-0 -left-20 w-[420px] h-[420px] rounded-full bg-[#0369a1]/20 blur-3xl" />
      <div className="container-x relative">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow text-sky-300">Why Wateriia</div>
            <h2 className="serif h-display mt-4 text-4xl sm:text-5xl lg:text-6xl">
              The difference is <br />
              <span className="italic text-sky-300">in the details.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-white/70">
            Designed for India's biggest cities — engineered for daily reliability and scale.
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {points.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={i}
                data-testid={`why-card-${i}`}
                className="rounded-3xl bg-white/[0.04] border border-white/10 p-7 hover:bg-white/[0.08] transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span className="serif text-xl text-sky-300">{p.no}</span>
                  <div className="h-10 w-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-sky-300">
                    <Icon size={16} />
                  </div>
                </div>
                <h3 className="serif h-display mt-6 text-2xl">{p.title}</h3>
                <p className="mt-3 text-white/70 leading-relaxed text-sm">{p.body}</p>
                <div className="mt-6 pt-5 border-t border-white/10 flex items-baseline justify-between">
                  <span className="serif text-3xl">{p.stat}</span>
                  <span className="text-[11px] uppercase tracking-widest text-white/50">{p.statLabel}</span>
                </div>
              </div>
            );
          })}

          {/* The promise card */}
          <div className="rounded-3xl bg-gradient-to-br from-[#0ea5e9] to-[#0369a1] p-7 md:p-9 lg:col-span-3 grid md:grid-cols-12 gap-6 items-center">
            <div className="md:col-span-7">
              <div className="eyebrow text-white/80">06 — The promise</div>
              <h3 className="serif h-display mt-3 text-3xl sm:text-4xl">
                If it isn't pure, it isn't <span className="italic">Wateriia.</span>
              </h3>
            </div>
            <div className="md:col-span-5 md:border-l md:border-white/20 md:pl-7 text-white/85">
              Every bottle is sealed, tracked and delivered with the same standard — whether it's one or ten thousand.
              <div className="mt-4 inline-flex items-center gap-2 text-white">
                <Droplets size={16} /> <span className="text-sm font-semibold">Purity. Promise. Practice.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
